<template>
  <div>
    <h4>
      <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
      Blocs récapitulatifs
    </h4>

    <BlocsRecapitulatifs :blocs_recap="parcours.blocs_recap"></BlocsRecapitulatifs>
    <hr />
    <h4>
      <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
      Contenu
    </h4>
    <b-row>
      <b-col sm="9">
        <b-row v-if="parcours.content.length > 0">
          <b-col
            style="margin-bottom: 20px"
            cols="12"
            v-for="(block, index) in parcours.content"
            :key="index"
          >
            <TextBlockContainer
              v-if="block.type === 'text'"
              :content="block.content"
              :index="index"
              :key="index"
              @updateContent="updateTextContent"
              @shiftUpBlock="shiftUpBlock"
              @shiftDownBlock="shiftDownBlock"
              @deleteBlock="deleteBlock"
            ></TextBlockContainer>
            <ImageBlockContainer
              v-if="block.type === 'image'"
              :index="index"
              :image_property="block"
              @shiftUpBlock="shiftUpBlock"
              @shiftDownBlock="shiftDownBlock"
              @deleteBlock="deleteBlock"
            ></ImageBlockContainer>
            <ButtonBlockContainer
              v-if="block.type === 'button'"
              :index="index"
              :button_property="block"
              @shiftUpBlock="shiftUpBlock"
              @shiftDownBlock="shiftDownBlock"
              @deleteBlock="deleteBlock"
            ></ButtonBlockContainer>
            <IframeBlockContainer
              v-if="block.type === 'iframe'"
              :index="index"
              :iframe_property="block"
              @shiftUpBlock="shiftUpBlock"
              @shiftDownBlock="shiftDownBlock"
              @deleteBlock="deleteBlock"
            ></IframeBlockContainer>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col>
            <b-alert show variant="warning"
              >Aucun contenu pour ce parcours, ajouter des élements via la
              sidebar</b-alert
            >
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="3">
        <div id="sidebar_parcours_builder">
          <h3>Elements</h3>
          <b-button @click="addBlockText()"
            ><b-icon icon="plus" aria-hidden="true"></b-icon> Bloc de
            texte</b-button
          >
          <b-button @click="addBlockImage()"
            ><b-icon icon="plus" aria-hidden="true"></b-icon> Image</b-button
          >
          <b-button @click="addBlockButton()"
            ><b-icon icon="plus" aria-hidden="true"></b-icon> Bouton</b-button
          >
          <b-button @click="addBlockIframe()"
            ><b-icon icon="plus" aria-hidden="true"></b-icon> Iframe</b-button
          >
          <hr />
          <h3>Couleurs</h3>
          <color-panel
            v-model="picked_color"
            style="max-width: 100%; margin-top: 10px"
          ></color-panel>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="align_center" style="margin-top: 20px">
        <b-button class="button_save_admin" @click="saveParcoursExtraContent"
          >Enregistrer les infos de parcours</b-button
        >
      </b-col>
    </b-row>
    <hr />
    <div id="galery_container">
      <div class="title_step">
        <h2>
          <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
          Galerie photo
        </h2>
      </div>
      <p>
        La galerie photo vous permet d'importer des images sur le serveur afin
        de les placer sur une page parcours. <br />
        Pour cela cliquer sur le bouton "add image" afin de l'importer. Elle
        apparaitra ainsi dans la galerie.<br />
        Cliquer sur l'image désirée, puis le bouton "copy link", et coller le
        lien dans le champs url du bloc image.
      </p>
      <ImageGalery></ImageGalery>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import TextBlockContainer from "@/components/Admin_tab/Blocks/TextBlockContainer.vue";
import ImageBlockContainer from "@/components/Admin_tab/Blocks/ImageBlockContainer.vue";
import ButtonBlockContainer from "@/components/Admin_tab/Blocks/ButtonBlockContainer.vue";
import IframeBlockContainer from "@/components/Admin_tab/Blocks/IframeBlockContainer.vue";
import ImageGalery from "@/components/Admin_tab/ImageGalery.vue";
import BlocsRecapitulatifs from "@/components/Admin_tab/BlocsRecapitulatifs.vue";
import { TextBlock } from "@/classes/Blocks/TextBlock.js";
import { ImageBlock } from "@/classes/Blocks/ImageBlock.js";
import { ButtonBlock } from "@/classes/Blocks/ButtonBlock.js";
import { IframeBlock } from "@/classes/Blocks/IframeBlock.js";
export default {
  components: {
    TextBlockContainer,
    TextBlock,
    ImageBlockContainer,
    ImageBlock,
    ButtonBlockContainer,
    ButtonBlock,
    IframeBlockContainer,
    IframeBlock,
    ImageGalery,
    BlocsRecapitulatifs,
  },
  props: ["parcours"],
  data() {
    return {
      picked_color: "#000",
    };
  },
  methods: {
    saveParcoursExtraContent() {
      var _this = this;
      var data = new FormData();
      var content = JSON.stringify(this.parcours.content);
      var recap = JSON.stringify(this.parcours.blocs_recap);
      data.append("action", "extra");
      data.append("id_module", this.parcours.id_module);
      data.append("id_parcours", this.parcours.id_parcours);
      data.append("nom_parcours", this.parcours.nom_parcours);
      data.append("blocs_recap", recap);
      data.append("content", content);
      axios
        .post(this.$store.state.base_url + "/admin/update.php", data)
        .then(function (response) {
        });
    },
    addBlockText() {
      let block = new TextBlock("text");
      this.parcours.content.push(block);
    },
    addBlockImage() {
      let block = new ImageBlock("image");
      this.parcours.content.push(block);
    },
    addBlockButton() {
      let block = new ButtonBlock("button");
      this.parcours.content.push(block);
    },
    addBlockIframe() {
      let block = new IframeBlock("iframe");
      this.parcours.content.push(block);
    },
    shiftUpBlock(index) {
      var block = this.parcours.content[index];
      this.parcours.content.splice(index, 1);
      this.parcours.content.splice(index - 1, 0, block);
      this.$forceUpdate();
    },
    shiftDownBlock(index) {
      var block = this.parcours.content[index];
      this.parcours.content.splice(index, 1);
      this.parcours.content.splice(index + 1, 0, block);
      this.$forceUpdate();
    },
    deleteBlock(index) {
      this.parcours.content.splice(index, 1);
      this.$forceUpdate();
    },
    updateTextContent(args) {
      this.parcours.content[args.index].content = args.content;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>